/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Explorer_AriaInputs */



/**
* | output |
* | --- |
* | "File explorer with drag and drop" |
*
* @param {Spaces_File_Explorer_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_explorer_aria = /** @type {((inputs?: Spaces_File_Explorer_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Explorer_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei-Explorer mit Drag & Drop")
	return /** @type {LocalizedString} */ ("File explorer with drag and drop")
});